import { render, staticRenderFns } from "./IndexMarket.vue?vue&type=template&id=74381232&scoped=true"
import script from "./IndexMarket.vue?vue&type=script&lang=js"
export * from "./IndexMarket.vue?vue&type=script&lang=js"
import style0 from "./IndexMarket.vue?vue&type=style&index=0&id=74381232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74381232",
  null
  
)

export default component.exports